export function countWords(value) {
  return (value || '').trim().split(/\s+/).filter(Boolean).length;
}

export function buildLegacySections(raw) {
  if (!raw || (!raw.includes('\n## ') && !raw.startsWith('## '))) return null;
  return raw
    .split(/\n---\n/)
    .map((block, index) => {
      const lines = block.trim().split('\n');
      const titleLine = lines.find(line => line.startsWith('## '));
      const documentHeading = titleLine ? titleLine.replace(/^##\s+/, '').trim() : `Section ${index + 1}`;
      const body = lines.filter(line => !line.startsWith('## ')).join('\n').trim();
      return {
        id: `legacy_${index + 1}`,
        editor_label: documentHeading,
        document_heading: documentHeading,
        body,
        guidance: '',
        placeholders: [],
        level: 2,
        kind: 'body',
        locked_heading: false,
        required: true,
      };
    })
    .filter(section => section.document_heading || section.body);
}

export function normalizeStructuredContent(doc) {
  const structured = doc?.structured_content;
  if (structured?.sections?.length) return structured;

  const templateSections = doc?.template_snapshot?.editor_schema?.sections;
  if (templateSections?.length) {
    return {
      version: doc?.template_snapshot?.editor_schema?.version || 2,
      template_id: doc?.template_snapshot?.template_id || doc?.parent_template_id || null,
      sections: templateSections.map((section, index) => ({
        id: section.id || `template_${index + 1}`,
        editor_label: section.editor_label || `Section ${index + 1}`,
        document_heading: section.document_heading ?? null,
        body: section.body || '',
        guidance: section.guidance || '',
        placeholders: section.placeholders || [],
        level: section.level || 2,
        kind: section.kind || 'body',
        locked_heading: Boolean(section.locked_heading),
        required: section.required !== false,
      })),
    };
  }

  const legacySections = buildLegacySections(doc?.content || '');
  if (legacySections?.length) {
    return {
      version: 1,
      template_id: doc?.parent_template_id || null,
      sections: legacySections,
    };
  }

  return null;
}

export function structuredSectionsToMarkdown(sections = []) {
  return sections
    .flatMap(section => {
      const blocks = [];
      if (section.document_heading) {
        const level = Math.min(Math.max(Number(section.level) || 2, 1), 6);
        blocks.push(`${'#'.repeat(level)} ${section.document_heading}`);
      }
      if (section.body?.trim()) {
        blocks.push(section.body.trim());
      }
      return blocks;
    })
    .join('\n\n')
    .trim();
}

export function getSectionTitle(section, fallback = 'Section') {
  return section?.document_heading || section?.editor_label || fallback;
}

export function getTemplateSourceSummary(doc) {
  const refs = doc?.template_snapshot?.official_references || [];
  return refs.map(ref => ref.title).join(' • ');
}

